export const PATIENT_KEYS = {
  all: ['patient'] as const,
  byId: (userid: string | number) => [...PATIENT_KEYS.all, String(userid)] as const,
  record: (userid: string | number) => [...PATIENT_KEYS.byId(userid), 'record'] as const,
  measures: (userid: string | number, days?: number) => [...PATIENT_KEYS.byId(userid), 'measures', days ?? 90] as const,
  measureReadings: (userid: string | number, meastypes: string) => [...PATIENT_KEYS.byId(userid), 'measure-readings', meastypes] as const,
  notes: (userid: string | number) => [...PATIENT_KEYS.byId(userid), 'notes'] as const,
  devices: (userid: string | number) => [...PATIENT_KEYS.byId(userid), 'devices'] as const,
} as const;
